import { Accordion } from '../../../../../components/general/accordion';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { PqrAlertHistoryProps } from './props';
import { usePqrAlertHistory } from './hook';
import { Table } from '../../../../../components/general/table';

export const PqrAlertHistory = (props: PqrAlertHistoryProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrAlertHistory(props);
    return (
        <Accordion
            title="HISTÓRICO ALERTAS"
            icon={<AnnouncementIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
